import { mutationOptions } from '@tanstack/react-query';

import { merchantApi } from './merchant.api';

export function createMerchantOnboardingLinkOptions() {
    return mutationOptions({
        // Offline, the default 'online' mode pauses the mutation, leaving the caller's blank tab open.
        networkMode: 'always',
        mutationFn: () => merchantApi.createOnboardingLink(),
    });
}

export function createMerchantDashboardLinkOptions() {
    return mutationOptions({
        // Offline, the default 'online' mode pauses the mutation, leaving the caller's blank tab open.
        networkMode: 'always',
        mutationFn: () => merchantApi.createDashboardLink(),
    });
}
